//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import { BCarousel, BCarouselSlide } from 'bootstrap-vue'

export default {

    name: 'HeaderSlider',

/*    components: {
        BCarousel: () => import('bootstrap-vue'),
        BCarouselSlide: () => import('bootstrap-vue'),
    },*/

    components: { BCarousel, BCarouselSlide },

    props: {
        sliderItems: {
            type: Array,
            default: {}
        },

    },

    data() {
        return {
            slide: 0,
        }
    },

}

